export default __webpack_public_path__ + "static/media/CNo.88-2.3685db3c.jpg";